<template>
	<div>
		<h2>Spesifikasjoner</h2>
		<div class="grid-columns-2">
			<div>
				<div
					v-for="(title, i) in firstHalf"
					:key="i"
					class="attribute-container"
				>
					<h3>{{ title }}</h3>
					<div
						v-for="(entry, i) in eCommerceProduct.attributes[title]"
						:key="i"
					>
						<div
							v-for="(value, key) in entry"
							:key="key"
						>
							<h4>{{ key === "GTIN" ? "GTIN/EAN" : key }}</h4>
							<p>
								{{ value }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div
					v-for="(title, i) in lastHalf"
					:key="i"
					class="attribute-container"
				>
					<h3>{{ title }}</h3>
					<div
						v-for="(entry, i) in eCommerceProduct.attributes[title]"
						:key="i"
					>
						<div
							v-for="(value, key) in entry"
							:key="key"
						>
							<h4>{{ key }}</h4>
							<p>
								{{ value }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ECommerceProductMixin from "../../ECommerceProductMixin/ECommerceProductMixin.js";
export default defineNuxtComponent({
	name: "ProductAttributes",
	mixins: [ECommerceProductMixin],

	computed: {
		sortedAttributes() {
			return Object.keys(this.eCommerceProduct.attributes).sort();
		},
		firstHalf() {
			const list = this.sortedAttributes;
			const half = Math.ceil(list.length / 2);

			return list.splice(0, half);
		},
		lastHalf() {
			const list = this.sortedAttributes;
			const half = Math.ceil(list.length / 2);

			return list.splice(-half);
		},
	},
});
</script>

<style lang="scss" scoped>
h2 {
	text-align: center;
	margin: 24px;

	@include font-title-xl;
}

h3 {
	@include font-title-l;
}

h4 {
	margin-top: 8px;

	@include font-title-s;
}

.attribute-container {
	padding: 24px 0;
	border-top: 1px solid #dbdbdb;
}

p {
	@include font-text-xs;
}
</style>
